import * as React from "react";
import memoizeOne from "memoize-one";
import { connect } from "react-redux";
import { formatMessage } from "lib/globalize-util";
import { IStore } from "reducers";
import Page from "components/page";
import { ProductCollectionHeader } from "components/product-collection/product-collection-header";
import { theme } from "styles/theme";
import * as actions from "actions/collections";
import {
    fetchBrands,
    fetchSingleBrand,
    collectionHistoryUndo,
    collectionHistoryRedo,
    fetchProducts,
    clearAllocationBag,
} from "actions/collections";
import { Map, List, Set } from "immutable";
import { merge, $, media } from "glamor";
import { addToSelectedItems, removeFromSelectedItems, clearAllSelectedItems } from "actions/bulk-items";
import PageNotFound from "components/page-not-found";
import * as PropTypes from "prop-types";
import { AlertDialog, ConfirmDialog } from "components/dialog";
import {
    IParams,
    View,
    ITEMS_ID,
    ROOT_NAMESPACE,
    ITEMS_NAMESPACE,
    CollectionKeys,
    Kinds,
} from "constants/product-collection";
import moment from "moment";
import {
    parseSchema,
    IDisplayFields,
    parseAssortmentId,
    getVersionStatusForPoi,
    getLatestPoi,
} from "helpers/product-collection";
import { IDoor } from "helpers/door-collection";
import { ICollectionVersionStatus } from "helpers/collection-version-status";
import { fetchGlobalProducts, fetchNextGlobalProducts, resetGlobalProducts } from "actions/global-products";
import { Chat } from "components/product-collection/product-collection-side-panel/product-collection-side-panel-chat";
import { ShimmerLoader } from "components/loading/shimmer-loader";
import { CollectionPOI } from "records/collection/poi";
import { ProductCollectionSummary } from "components/product-collection";
import { GridApi, ColumnApi } from "ag-grid-community";
import { ProductCollectionAppBar } from "components/product-collection/product-collection-app-bar";
import {
    IProductCollectionContext,
    ProductCollectionContext,
} from "components/product-collection/product-collection-context";
import { ProductDetailsModal } from "components/product-collection/product-collection-views/product-collection-detail-view";
import { PendingMutationModal } from "components/product-collection/product-collection-views/pending-mutation-modal";
import uuid from "uuid/v4";
import app from "lib/app";
import { COLLECTIONS } from "constants/action-types";
import { DATATEST } from "constants/integration";
import get from "lodash/get";
import isEqual from "lodash/isEqual";
import isEmpty from "lodash/isEmpty";
import { retrySync } from "actions/mutate";
import { getCollectionItems, getCollectionTags, getDoors } from "reducers/selectors/collection";
import { DRIVE_LINK } from "containers/folders/utils/constants";
import { AssortmentManageAccessDialog } from "containers/folders/containers/space-manager/components/manage-access/assortment-manage-access-dialog";
import { nameExtRemover } from "containers/folders/utils/space-item";
import { ItemKind } from "containers/folders/types/base";
import { getActiveMerchantCollectionVersionStatus } from "../../reducers/selectors/merchant/merchant-collection-version-status";
import me from "models/me";
import { IRollupSnapshotResponse, RollupType } from "containers/folders/types/server-rollups";
import { fetchBrandsData, IFetchBrandsDataPayload } from "actions/brands-data-actions";
import { IBrandsDataStatePayload } from "reducers/brands-data-reducers";
import { ReopenServerRollupDialog } from "containers/folders/containers/space-manager/components/dialogs/reopen-server-rollup";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import { CollectionType } from "containers/folders/types/assortment";
import { spaceItem } from "containers/folders/services/space-item";
import { serverRollup } from "containers/folders/services/server-rollups";
import { parseFilters } from "components/product-collection/product-collection-views/product-collection-grid-view/tool-panels/shop-tool-panel/helpers";
import { IN_ASSORTMENT } from "./product-collection-shop-brand-catalog";
import { shallowEqualAndExclude } from "helpers/performance/shallow-compare-exclude";
import * as shallowCompare from "react-addons-shallow-compare";
import { CUSTOM_VIEW_SETTINGS, DEFAULT_VIEW_SETTINGS } from "components/product-collection/manage-tile-view/constants";
import { IShopViewSettings } from "components/product-collection/manage-shop-view/types";
import { ManageShopView } from "components/product-collection/manage-shop-view";
import { FeatureFlags } from "helpers/feature-flags";
import { getMerchantDefaultAllocationDimensionsPreferenceRequest } from "actions/merchant";
import { MarketSettingsModal } from "components/product-collection/market-settings";
import {
    MarketSettingsData,
    MarketSettingsNotifierEvent,
    SaveAssormentSettingsRequest,
} from "components/product-collection/market-settings/market-settings.types";
import { DimensionsPanelReduxState } from "reducers/dimensions-panel/dimensions-panel";
import { KEYBOARD_KEYS } from "constants/keyboard";
import { MANAGE_TARGETS_MODAL_ID } from "components/product-collection/footer/components/left-side/manage-target-modal";
import { FINANCIAL_TARGET_FORM_ID } from "components/product-collection/footer/components/financial-target-form/financial-target-form";
import { isRollupContainingTrashedItem } from "containers/folders/hooks/utils";

const FOUR_HOURS_IN_MS = 4 * 60 * 60 * 1000;
const TWO_MINUTES_IN_MS = 120000;

const disableKeydownListenerQueries: (() => boolean)[] = [
    () => Boolean(document.getElementById(FINANCIAL_TARGET_FORM_ID)),
    () => Boolean(document.getElementById(MANAGE_TARGETS_MODAL_ID)),
];

interface IStateToProps {
    hasAccessToBrand: boolean;
    assortmentBagVersion: string;
    collection?: Map<string, any>;
    rollupSnapshot?: object;
    collectionDriveItem: nuorder.folder.v1.Item;
    capabilities: nuorder.folder.v1.Capabilities;
    itemDisplayProperty?: List<any>;
    items?: List<any>;
    itemsId?: string;
    sessionId?: string;
    merchantId: string;
    collectionItemMerchantId: string;
    bulkItems: any;
    hashtags: Set<string>;
    gridApi?: GridApi;
    scrollToIndex?: number;
    collectionError: any;
    router: any;
    syncingProducts: boolean;
    focusOnCellMap: Map<string, any>;
    activeUserSessions: Map<string, any>;
    brandIds: string[];
    brandEntities: any;
    brandsDataById: IBrandsDataStatePayload["brandsDataById"];
    isFetchingBrandsData: boolean;
    syncError: any;
    app: any;
    isOutOfDate: boolean;
    chatState: any;
    chatStateError?: any;
    poiEntities?: { [collectionPoiId: string]: CollectionPOI };
    scope: any;
    brandFetched: boolean;
    isSaving: boolean;
    preventNavigation: boolean;
    bulkAddingItems: boolean;
    historyItems?: List<any>;
    historyItemDisplayProperty?: List<any>;
    globalProducts: any;
    globalProductState: any;
    isFetchingModal: boolean;
    onResetChatState: ({ namespace, id, meta }) => void;
    chatMessageEntities: any;
    isFetchingProducts: boolean;
    variantIds: any;
    productError: any;
    productId: string;
    collectionProduct: any;
    catalog: any;
    catalogs: any;
    entries: any;
    doors: IDoor[];
    collectionItemsPendingMutation?: object | null;
    isRollupMode?: boolean;
    rollupType?: RollupType;
    assortmentIds?: string[];
    assortmentIdsCollected?: string[];
    sizingAllocationEnabled: boolean;
    allowDuplicateProduct: boolean;
    listMerchantCollectionVersionStatutes: ICollectionVersionStatus[];
    poiTags: List<any>;
    recreateServerRollupSnapshot?: boolean;
    serverRollupSnapshotId?: string;
    createServerRollupSnapshotError?: any;
    viewId: string;
    isCollectionSettingsOpen?: boolean;
    dimensionsPanelApplied: DimensionsPanelReduxState | null;
}

interface IActions {
    onSubscribeToSessionUpdates: (collectionId) => void;
    onUnsubscribeToSessionUpdates: () => void;
    onSubscribeToItemsUpdates: (collectionId: string, itemsId: string, sessionId: string) => void;
    onUnsubscribeToItemsUpdates: (collectionId: string, itemsId: string) => void;
    onUnsubscribeToChatUpdates: (params: { namespace: string; id: string }) => void;
    onResetChat: (params: { namespace: string; id: string; meta: any }) => void;
    onGetOrCreateSession: (collectionId: string, userId: string, merchantId: string, editable: boolean) => void;
    onClearSession: () => void;
    onFetchCollection: (ids: string[], isServerRollup: boolean, isCloseoutAssortmentEnabled: boolean) => void;
    onAddItem: (params: actions.IAddItem) => void;
    onMutateCollectionBudget: (collectionId: string, value: any) => void;
    onMutateCollectionItem: (itemsId, index, item, value?) => void;
    onRemoveItem: (itemsId: string, index: number) => void;
    onMoveItem: (itemsId: string, index: number, destinationIndex: number) => void;
    onBulkItemsClearAll: () => void;
    onAddBulkItems: (catalogId, itemsId, lastIndex, collectionId, inAssortment) => void;
    onBulkItemsAdd: (id) => void;
    onBulkItemsRemove: (id) => void;
    onBulkItemsToggleSelectAll: () => void;
    onDeleteItemsViaBulkItems: (itemsId, bulkItems, options?) => void;
    onCreateCollectionAsset: (
        collectionId: string,
        uploadData: any,
        fileData: any,
        item: any,
        index: number,
        itemsId: string,
        key: string,
        assetIndex: number
    ) => void;
    onGridMount: (api: GridApi, columnApi: ColumnApi) => void;
    onUpdateCollectionAttribute: (id: string, prop: string, value: any, reset?: boolean) => void;
    onOpenOrCloseCollectionSettings: (payload: boolean) => void;
    onUpdateCollectionSettings: (payload: SaveAssormentSettingsRequest) => void;
    onDeleteCollection: (id: string) => void;
    onFetchContacts: (search: string, merchant_id: string, brandId?: string) => void;
    onSyncProductsStart: () => void;
    onSyncProductsStop: () => void;
    onFocusChange: (collectionId: string, itemsId: string, field: string) => void;
    onFetchBrandsData: (query: IFetchBrandsDataPayload["query"]) => void;
    onFetchBrands: (options?) => void;
    onFetchSingleBrand: (brandId?) => void;
    onClearProductUpdates: () => void;
    onCheckForProductUpdates: () => void;
    onClearCollection: (itemsId?) => void;
    onCreateNordstromPush: (params: any) => void;
    onFetchGlobalProducts: (params) => void;
    onFetchNextGlobalProducts: (params) => void;
    onResetGlobalProducts: (params) => void;
    onUndo: () => void;
    onRedo: () => void;
    onGetCollectionChatMessages: (collectionId: string, options?: any) => void;
    onCreateCollectionChatMessage: (collectionId: string, data: any, meta?: any) => void;
    onDeleteCollectionChatMessage: (messageId: string, chatThreadId: string) => void;
    onResetChatAlert: () => void;
    onFetchProducts: (productId: string, brandId: string) => void;
    onHeartbeatCheck: () => void;
    collectionRequestDeletePendingMutation: (documentId: string, objectNamespace: string, objectId: string) => void;
    collectionRetrySync: (objectNamespace: string, objectId: string) => void;
    collectionGridXlsExport: (collection: any, assortmentIds?: string[]) => void;
    collectionClearSyncError: () => void;
    getMerchantDefaultAllocationDimensionsPreference: (merchantId: string) => void;
}

interface IProps extends IStateToProps, IActions {
    params: IParams;
    location: any;
    router: any;
    route: any;
    flags: FeatureFlags;
}

interface IState {
    isNew: boolean;
    showChat: boolean;
    shareDialogOpen: boolean;
    productIdForModal: string;
    nextLocation: any;
    shopViewSettings: IShopViewSettings;
    selectedShopViewSetting: string;
    isConfigureShopViewOpen: boolean;
    collectionNotFoundInRollup: boolean;

    // schema fields
    detailDisplayFields: List<any>;
    shopViewFields: IDisplayFields;
    serverRollupChecked: boolean;
    contextValue?: IProductCollectionContext;
}

const updateExclusionList = ["preventNavigation"];
class ProductCollectionPage extends React.Component<IProps, IState> {
    static contextTypes = {
        me: PropTypes.object.isRequired,
    };

    sectionToolbarContentRef = React.createRef<HTMLDivElement>();

    private styles = merge(
        {
            position: "relative",
            height: "100%",
            minHeight: "100%",
            padding: "0px 1px 1px 0px",
        },
        $(" .mainPanel", {
            userSelect: "none",
            height: "100%",
        }),
        media(
            "(min-width: 750px)",
            $(" .ag-tool-panel", {
                borderRight: "none !important",
            })
        ),
        /**
         * z-index:
         * Overlay: 998
         * Drawer: 999
         * Assortment Header: 1000
         * MenuButton: 1002
         */
        media(
            "(max-width: 749px)",
            $(" .assortmentSidePanel", {
                paddingTop: 0,
            })
        ),
        $(" .layoutContainerMain", {
            padding: "0px !important",
            display: "flex",
            flexDirection: "column",
        }),
        $(" .assortmentBody", {
            flexGrow: 1,
            flexShrink: 1,
            display: "flex",
        }),
        $(" .assortmentBodyMain", {
            flexGrow: 1,
            flexShrink: 1,
            display: "flex",
            flexDirection: "column",
        }),
        $(" .assortmentBodyContent", {
            display: "flex",
            flexGrow: 1,
            flexShrink: 1,
        }),
        $(" .assortmentChat", {
            height: "auto",
            flexGrow: 0,
            flexShrink: 0,
            position: "relative",
            width: "300px",
            overflowY: "hidden",
        }),
        media(
            "(max-width: 500px)",
            $(" .assortmentChat", {
                position: "absolute",
                right: 0,
                top: 0,
                bottom: 0,
                left: 0,
                width: "auto",
                height: "auto",
                zIndex: 10,
                overflow: "hidden",
            })
        ),
        $(" .share", {
            color: theme.palette.lightGrey,
            fontSize: "16px",
            fontWeight: "bold",
        }),
        $(" .assortmentTitle", {
            color: theme.palette.lightGrey,
            fontSize: "16px",
        })
    );

    private muiStyles = {
        dialog: {
            contentStyle: {
                maxWidth: "600px",
            },
            bodyStyle: {
                overflowY: "auto",
                padding: "0px",
            },
            titleStyleSmall: {
                marginLeft: "0px",
                marginRight: "0px",
                padding: "30px 0px 20px 24px",
                borderBottom: `1px solid ${theme.palette.borderColor}`,
            },
            titleStyle: {
                marginLeft: "0px",
                marginRight: "0px",
                padding: "24px 0px 20px 24px",
                borderBottom: `1px solid ${theme.palette.borderColor}`,
            },
            titleWrapper: {
                display: "flex",
                alignItems: "center",
            },
            titleLabelStyle: {
                fontSize: "18px",
                paddingLeft: "10px",
            },
            assortmentNameStyle: {
                color: theme.palette.grey,
                fontSize: "18px",
                wordBreak: "break-all",
                paddingRight: "10px",
                width: "60%",
                maxWidth: "310px",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
            },
        },
    };

    private ableToWatchForUpdates = 0; // once it gets to 2 we can
    private isWatching = false;
    private checkForProductUpdatesTimer = undefined;
    private sendHearbeat = undefined;
    private heartbeatReturned = true;

    constructor(props, context) {
        super(props, context);
        const { detailDisplayFields, shopViewFields } = parseSchema(props.itemDisplayProperty);
        this.state = {
            isNew: false,
            showChat: false,
            shareDialogOpen: false,
            productIdForModal: props.router.location.query.productId,
            nextLocation: undefined,
            detailDisplayFields,
            shopViewFields,
            serverRollupChecked: false,
            shopViewSettings: null,
            selectedShopViewSetting: DEFAULT_VIEW_SETTINGS,
            isConfigureShopViewOpen: false,
            collectionNotFoundInRollup: false,
        };
    }

    get baseAssortmetId() {
        const [baseAssortmetId] = this.props.assortmentIdsCollected || this.props.assortmentIds;
        return baseAssortmetId;
    }

    get isRollupMode() {
        return this.props.isRollupMode;
    }

    get canShopBrand() {
        const { brandEntities, collection, brandFetched, hasAccessToBrand } = this.props;

        const assortmentBrandId = collection?.getIn(["brand_collection_properties", "struct_value", "brand_id"]);

        const isBuyer = me.isBuyer();
        const hasValidBrand = !!brandEntities?.[assortmentBrandId] && hasAccessToBrand;
        const canShopBrand = isBuyer && assortmentBrandId && brandFetched ? hasValidBrand : true;

        return canShopBrand;
    }

    protected get isServerRollup() {
        return this.isRollupMode && this.props.rollupType === RollupType.Server;
    }

    protected get isCloseoutAssortmentEnabled() {
        return this.props.flags.closeoutAssortment;
    }

    async UNSAFE_componentWillMount() {
        await me.handleRegisterUserToLaunchdarkly();
        this.props.onFetchCollection(this.props.assortmentIds, this.isServerRollup, this.isCloseoutAssortmentEnabled);
        !this.isRollupMode && this.props.onGetCollectionChatMessages(this.baseAssortmetId, { limit: 30 });

        if (this.isServerRollup) {
            const { params, router, location } = this.props;
            const merchantId = me.getLastMerchantId();
            const { baseAssortmentId: snapshotId } = parseAssortmentId(params.id);
            const fetchItemInfoService = spaceItem.getItem(merchantId, snapshotId);
            const { parent } = await fetchItemInfoService;
            const lastSnapshotId = await serverRollup.getLastSnapshotId(parent, merchantId);
            if (!(!lastSnapshotId || snapshotId === lastSnapshotId)) {
                router.push({ pathname: `assortment/${lastSnapshotId}`, query: { ...location.query } });
                return;
            }
            this.setState({ serverRollupChecked: true });
        }

        if (this.props.itemsId) {
            this.ableToWatchForUpdates = this.ableToWatchForUpdates + 1;
        }
        if (this.props.sessionId) {
            this.ableToWatchForUpdates = this.ableToWatchForUpdates + 1;
        }
        if (!this.isRollupMode) {
            if (this.ableToWatchForUpdates === 2 && this.props.items && !this.isWatching) {
                this.isWatching = true;
                this.props.onSubscribeToItemsUpdates(this.baseAssortmetId, this.props.itemsId, this.props.sessionId);
            }

            if (!this.checkForProductUpdatesTimer && this.props.items && this.props.capabilities) {
                this.queueCheckForProductUpdates();
            }
        }

        if (!this.props.viewId && this.props.merchantId) {
            this.props.getMerchantDefaultAllocationDimensionsPreference(this.props.merchantId);
        }

        let queryUpdated = false;
        const newQuery = {
            ...this.props.location.query,
        };

        if (this.props.location.query.isNew) {
            this.setState({ isNew: true });
            delete newQuery.isNew;
            queryUpdated = true;

            if (this.props.flags.assortmentSettings) {
                const { onOpenOrCloseCollectionSettings } = this.props;
                onOpenOrCloseCollectionSettings(true);
            }
        }

        if (queryUpdated) {
            this.props.router.replace({
                pathname: this.props.location.pathname,
                query: newQuery,
            });
        }

        this.sendHearbeat = setInterval(this.handleSendHeartbeat, 30 * 1000);
        app.on(COLLECTIONS.COLLECTION.HEARTBEAT, this.handleHearHeartbeat);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);

        if (!this.isRollupMode) {
            this.props.onUnsubscribeToItemsUpdates(this.baseAssortmetId, this.props.itemsId);
            this.props.onUnsubscribeToChatUpdates({ namespace: ROOT_NAMESPACE, id: this.baseAssortmetId });
            this.props.onResetChat({
                namespace: ROOT_NAMESPACE,
                id: this.baseAssortmetId,
                meta: {
                    hasMore: false,
                },
            });
        }
        this.props.onUnsubscribeToSessionUpdates();
        this.props.onClearSession();
        this.props.onClearCollection(this.props.itemsId);
        clearTimeout(this.checkForProductUpdatesTimer);
        // clear out pending mutations in indexDB on unmount
        this.props.collectionRequestDeletePendingMutation(this.baseAssortmetId, ITEMS_NAMESPACE, ITEMS_ID);
        this.checkForProductUpdatesTimer = undefined;

        // if (this.state.showSidePanel && (this.props.app.viewport === "mobile" || this.props.app.viewport === "phablet")) {
        //     document.body.style.position = "";
        //     document.body.style.width = "";
        // }

        clearInterval(this.sendHearbeat);
        app.off(COLLECTIONS.COLLECTION.HEARTBEAT, this.handleHearHeartbeat);
    }

    UNSAFE_componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.itemsId !== this.props.itemsId) {
            this.ableToWatchForUpdates = this.ableToWatchForUpdates + 1;
        }
        if (nextProps.sessionId !== this.props.sessionId) {
            this.ableToWatchForUpdates = this.ableToWatchForUpdates + 1;
        }

        if (!parseAssortmentId(nextProps.params.id).isRollupMode) {
            if (this.ableToWatchForUpdates === 2 && nextProps.items && !this.isWatching) {
                this.isWatching = true;
                this.props.onSubscribeToItemsUpdates(nextProps.params.id, nextProps.itemsId, nextProps.sessionId);
            }

            if (!this.checkForProductUpdatesTimer && nextProps.items && nextProps.capabilities) {
                this.queueCheckForProductUpdates();
            }
        }

        if (this.props.location.search !== nextProps.location.search) {
            const newProdId = nextProps.location.query.productId;
            this.state.productIdForModal !== newProdId && this.setState({ productIdForModal: newProdId });
        }

        if (!isEqual(this.props.itemDisplayProperty, nextProps.itemDisplayProperty)) {
            const { detailDisplayFields, shopViewFields } = parseSchema(nextProps.itemDisplayProperty);
            this.setState({
                detailDisplayFields,
                shopViewFields,
                shopViewSettings: this.getInitialShopSettings(nextProps.itemDisplayProperty),
            });
        }

        const nextBagVersion = nextProps.assortmentBagVersion;
        const prevBagVersion = this.props.assortmentBagVersion;
        const nextMerchantId = nextProps.collectionDriveItem?.collection_facet?.merchant_id;
        const prevMerchantId = this.props.collectionDriveItem?.collection_facet?.merchant_id;
        if (nextBagVersion !== prevBagVersion || nextMerchantId !== prevMerchantId) {
            me.handleRegisterUserToLaunchdarkly({ merchantId: nextMerchantId, assortmentBagVersion: nextBagVersion });
        }
    }

    shouldComponentUpdate(nextProps: IProps, nextState: IState) {
        return (
            shallowEqualAndExclude(this.props, nextProps, updateExclusionList) ||
            shallowCompare(this, this.props, nextState)
        );
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown);

        // TODO: Probably move this call to header for brand picker?
        // if (me.isBrandUser()) {
        //     options.assortment_brands_only = true;
        // }

        if (!this.isRollupMode && !this.context.me.last_brand) {
            this.props.onFetchBrands({ assortment_brands_only: true });
        }

        if (!this.isRollupMode) {
            this.props.onFetchSingleBrand(this.context.me.last_brand);
        }

        if (!this.isRollupMode && this.props.sessionId) {
            this.props.onSubscribeToSessionUpdates(this.baseAssortmetId);
        }

        this.props.router.setRouteLeaveHook(this.props.route, ({ pathname }) => {
            const { preventNavigation } = this.props;
            if (preventNavigation && !this.state.nextLocation) {
                this.handleNavigationPrevented(pathname);
            }
            return !preventNavigation || (preventNavigation && !!this.state.nextLocation);
        });
    }

    computeContextValue() {
        const { doors, isRollupMode, rollupType, brandEntities } = this.props;
        const { contextValue, shopViewSettings } = this.state;

        const newState = {
            sectionToolbarContentRef: this.sectionToolbarContentRef,
            hasDoors: doors.length > 0,
            doors,
            isRollupMode,
            rollupType,
            canShopBrand: this.canShopBrand,
            brandEntities,
            shopViewSettings,
        };

        // Every value that is inside the contextValue should be updated by direct comparison
        // else, context values won't update inside components that use them.
        // That is, please add contextValue.prop !== this.(state | props).prop whenever you introduce
        // a new prop/state whose value (or a derived value) is part of contextValue.
        if (
            !contextValue ||
            contextValue.brandEntities !== brandEntities ||
            contextValue.canShopBrand !== this.canShopBrand ||
            (!contextValue.doors?.length && doors.length) ||
            contextValue.shopViewSettings !== shopViewSettings
        ) {
            this.setState({ contextValue: newState });
        }
    }

    componentDidUpdate(prevProps: IProps) {
        if (!isEqual(prevProps.assortmentIds, this.props.assortmentIds)) {
            // Easiest way to avoid bugs, not a big use case
            this.windowReload();
        }
        if (this.isRollupMode && this.props.rollupSnapshot && !prevProps.rollupSnapshot) {
            if (isRollupContainingTrashedItem(this.props.rollupSnapshot as IRollupSnapshotResponse)) {
                this.setState({ collectionNotFoundInRollup: true });
            }
        }

        if (!this.props.viewId && this.props.merchantId && !prevProps.merchantId) {
            this.props.getMerchantDefaultAllocationDimensionsPreference(this.props.merchantId);
        }

        this.computeContextValue();
        if (!this.isRollupMode) {
            if (this.props.sessionId && !prevProps.sessionId) {
                this.props.onSubscribeToSessionUpdates(this.baseAssortmetId);
            }

            if (!prevProps.capabilities && this.props.capabilities) {
                const editable = this.hasEditPermissions();
                this.props.onGetOrCreateSession(
                    this.baseAssortmetId,
                    this.context.me._id,
                    this.props.merchantId,
                    editable
                );
            }

            const prevBrandId =
                (prevProps.collection &&
                    prevProps.collection.getIn(["brand_collection_properties", "struct_value", "brand_id"])) ||
                prevProps.params.brand;
            const brandId =
                (this.props.collection &&
                    this.props.collection.getIn(["brand_collection_properties", "struct_value", "brand_id"])) ||
                this.props.params.brand;

            if (prevBrandId !== brandId && brandId) {
                this.props.onFetchSingleBrand(brandId);
            }
        }
    }

    handlePendingMutationExport = () => {
        this.props.collectionGridXlsExport(this.props.collection, this.props.assortmentIdsCollected);
    };

    handlePendingMutationSyncRetry = () => {
        const { collectionRetrySync, collectionClearSyncError } = this.props;
        collectionRetrySync(ITEMS_NAMESPACE, ITEMS_ID);
        collectionClearSyncError();
    };

    handlePendingMutationClear = () => {
        const { collectionClearSyncError } = this.props;
        collectionClearSyncError();
        this.windowReload(true);
    };

    handleCloseAssortmentSettings = () => {
        const { onOpenOrCloseCollectionSettings } = this.props;
        onOpenOrCloseCollectionSettings(false);
    };

    handleSaveAssortmentSettings = (payload: MarketSettingsData, notifier: MarketSettingsNotifierEvent) => {
        const { onUpdateCollectionSettings } = this.props;
        onUpdateCollectionSettings({
            ...payload,
            onSettled: notifier,
        });
    };

    windowReload = (clearPendingMutation = false) => {
        if (!this.isRollupMode && clearPendingMutation) {
            const { collectionRequestDeletePendingMutation } = this.props;
            collectionRequestDeletePendingMutation(this.baseAssortmetId, ITEMS_NAMESPACE, ITEMS_ID);
        }
        // Short timeout to let pending mutation deletes from indexed db.
        // Intermittenly, window reload can prevent deletion of record from indexed db.
        setTimeout(() => {
            window.location.reload();
        }, 500);
    };

    shouldRenderPendingMutationModal = () => {
        const { syncError, collectionItemsPendingMutation } = this.props;

        // If sync error is 403, it is permission error and we shouldn't show pending mutation modal
        return syncError && syncError.status !== 403 && collectionItemsPendingMutation;
    };

    maybeRenderErrorDialog = () => {
        const { syncError, chatStateError } = this.props;

        if (this.shouldRenderPendingMutationModal()) {
            return (
                <PendingMutationModal
                    modalOpen={true}
                    exportHandler={this.handlePendingMutationExport}
                    retryHandler={this.handlePendingMutationSyncRetry}
                    clearHandler={this.handlePendingMutationClear}
                />
            );
        }

        if (syncError || chatStateError) {
            let title = formatMessage("Sync Error");
            let message = formatMessage("Oops! Something went wrong, please refresh and try again.");
            if (syncError && syncError.status === 403) {
                title = formatMessage("Permissions Error");
                message = formatMessage(
                    "It seems your permissions on this assortment have changed or the assortment has been deleted. You will be directed back to your Drive."
                );
            }
            if (chatStateError && chatStateError.status === 403) {
                title = formatMessage("Permissions Error");
                message = formatMessage(
                    "It seems your permissions on this assortment have changed or the assortment has been deleted. You will be directed back to your Drive."
                );
            }

            return (
                <AlertDialog
                    open={true}
                    onRequestClose={this.handleAcknowledgeError}
                    actionLabel={formatMessage("Continue")}
                    title={title}
                >
                    {message}
                </AlertDialog>
            );
        }

        return null;
    };

    render() {
        const { me } = this.context;
        const {
            activeUserSessions,
            app,
            brandEntities,
            brandIds,
            chatState,
            children,
            collection,
            collectionDriveItem,
            capabilities,
            collectionError,
            globalProducts,
            isFetchingModal,
            items,
            location,
            onFetchGlobalProducts,
            onUpdateCollectionAttribute,
            poiEntities,
            router,
            scope,
            onGetCollectionChatMessages,
            onCreateCollectionChatMessage,
            onDeleteCollectionChatMessage,
            onResetChatAlert,
            onResetChatState,
            chatMessageEntities,
            entries,
            bulkAddingItems,
            doors,
            isRollupMode,
            rollupType,
            allowDuplicateProduct,
            listMerchantCollectionVersionStatutes,
            poiTags,
            brandFetched,
            brandsDataById,
            onFetchBrandsData,
            isFetchingBrandsData,
            recreateServerRollupSnapshot,
            serverRollupSnapshotId,
            createServerRollupSnapshotError,
            itemDisplayProperty,
            isCollectionSettingsOpen,
            merchantId,
            collectionItemMerchantId,
            dimensionsPanelApplied,
        } = this.props;
        const {
            isNew,
            showChat,
            shareDialogOpen,
            productIdForModal,
            detailDisplayFields,
            shopViewFields,
            isConfigureShopViewOpen,
            selectedShopViewSetting,
            shopViewSettings,
            contextValue,
        } = this.state;
        const editable = this.hasEditPermissions();

        if (!me.isSignedIn()) {
            // hack to handle 401 that server should have given but isn't because of JWT
            this.props.router.push("/login");
            return null;
        }

        const assortmentBrandId =
            collection && collection.getIn(["brand_collection_properties", "struct_value", "brand_id"]);

        if (router.params.brand && assortmentBrandId && router.params.brand !== assortmentBrandId) {
            return <PageNotFound />;
        }

        if (
            !isEmpty(brandEntities) &&
            assortmentBrandId &&
            brandEntities[assortmentBrandId] &&
            !isRollupMode &&
            this.canShopBrand &&
            collectionDriveItem
        ) {
            if (
                !get(brandEntities[assortmentBrandId], "modules.assortments.enabled") &&
                collectionDriveItem.collection_facet?.collection_type !== CollectionType.BrandStandard
            ) {
                return <PageNotFound />;
            }
        }

        if (collectionError && (collectionError.code === 403 || collectionError.code === 404)) {
            return <PageNotFound />;
        }
        if (
            !collection ||
            (!capabilities && !this.state.collectionNotFoundInRollup) ||
            !dimensionsPanelApplied ||
            (brandIds.length === 0 && !isRollupMode && this.canShopBrand && !brandFetched)
        ) {
            return <ShimmerLoader />;
        }
        if (this.isServerRollup && !this.state.serverRollupChecked) {
            return <div {...this.styles}></div>;
        }

        const breadcrumbs = this.setBreadcrumbs();
        const latestPoi = getLatestPoi(location.query.poi, poiEntities);
        const versionStatusLabel = getVersionStatusForPoi(
            latestPoi,
            poiTags,
            listMerchantCollectionVersionStatutes
        )?.label;
        const currentBrand = brandEntities[assortmentBrandId];

        return (
            <div {...this.styles}>
                <Page
                    showTitle={false}
                    showHeader={false}
                    openNavSection="wholesale"
                    title={
                        collectionDriveItem?.name &&
                        formatMessage(nameExtRemover(collectionDriveItem?.name, collectionDriveItem?.kind as ItemKind))
                    }
                >
                    {!this.state.collectionNotFoundInRollup && (
                        <>
                            <ProductCollectionHeader
                                me={me}
                                collectionId={this.baseAssortmetId}
                                collection={collection}
                                capabilities={capabilities}
                                onUpdateCollectionAttribute={onUpdateCollectionAttribute}
                                activeUserSessions={activeUserSessions}
                                isNew={isNew}
                                isCollectionSettingsOpen={isCollectionSettingsOpen}
                                rowDataSet={false}
                                location={location}
                                poiEntities={poiEntities}
                                onSubscribeToItemsUpdates={this.handleSubscribeToItemsUpdates}
                                router={router}
                                brandsDataById={brandsDataById}
                                onToggleChat={this.handleToggleChat}
                                showChat={showChat}
                                chatState={chatState}
                                params={this.props.params}
                                onToggleShare={this.handleToggleShareDialog}
                                isRollupMode={isRollupMode}
                                rollupType={rollupType}
                                collectionDriveItem={collectionDriveItem}
                                versionStatusLabel={versionStatusLabel}
                                onFetchBrandsData={onFetchBrandsData}
                                isFetchingBrands={isFetchingBrandsData}
                                userMerchantId={this.props.merchantId}
                                brand={currentBrand}
                            />
                            <ProductCollectionAppBar
                                router={router}
                                location={location}
                                sectionToolbarContentRef={this.sectionToolbarContentRef}
                                onAddBulkItems={this.handleBulkAddCatalogEntries}
                                entries={entries}
                                editable={editable}
                                bulkAddingItems={bulkAddingItems}
                                isRollupMode={isRollupMode}
                                canShopBrand={this.canShopBrand}
                                sizingAllocationEnabled={this.props.sizingAllocationEnabled}
                                allowDuplicateProduct={allowDuplicateProduct}
                                onConfigureShopView={this.handleToggleConfigureShopView}
                                onResetToDefaultShopView={this.setInitialShopSettings}
                                selectedShopViewKey={selectedShopViewSetting}
                            />
                            <div className="assortmentBody">
                                <div className="assortmentBodyMain">
                                    <ProductCollectionSummary
                                        brandEntities={brandEntities}
                                        links={breadcrumbs}
                                        scope={scope}
                                        router={router}
                                    />
                                    <div className="assortmentBodyContent">
                                        <ProductCollectionContext.Provider
                                            value={
                                                // Please remember to update contextValue on change
                                                contextValue ?? {
                                                    sectionToolbarContentRef: this.sectionToolbarContentRef,
                                                    hasDoors: doors.length > 0,
                                                    doors,
                                                    isRollupMode,
                                                    rollupType,
                                                    canShopBrand: this.canShopBrand,
                                                    brandEntities,
                                                    shopViewSettings,
                                                    onResetShopViewSettings: this.setInitialShopSettings,
                                                    flags: this.props.flags,
                                                }
                                            }
                                        >
                                            {children}
                                        </ProductCollectionContext.Provider>
                                    </div>
                                </div>
                                {showChat && (
                                    <div data-test={DATATEST.ASSORTMENTS.CHAT_PANEL} className="assortmentChat">
                                        <Chat
                                            app={app}
                                            collection={collection}
                                            collectionId={this.baseAssortmetId}
                                            onGetCollectionChatMessages={onGetCollectionChatMessages}
                                            onCreateCollectionChatMessage={onCreateCollectionChatMessage}
                                            onDeleteCollectionChatMessage={onDeleteCollectionChatMessage}
                                            onResetChatAlert={onResetChatAlert}
                                            onResetChatState={onResetChatState}
                                            chatMessageEntities={chatMessageEntities}
                                            chatState={chatState}
                                            activeUserSessions={activeUserSessions}
                                            onToggleSidePanel={this.handleToggleChat}
                                        />
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                    {this.maybeRenderErrorDialog()}

                    <ConfirmDialog
                        open={!!this.state.nextLocation}
                        title={formatMessage("Are you sure you want to leave this page?")}
                        onConfirm={() => this.state.nextLocation && this.props.router.push(this.state.nextLocation)}
                        onCancel={() => this.setState({ nextLocation: null })}
                        contentStyle={this.muiStyles.dialog.contentStyle}
                        cancelLabel={formatMessage("Cancel")}
                        confirmLabel={formatMessage("Leave")}
                    >
                        <p>
                            {formatMessage(
                                "There are unsaved changes in this assortment. If you leave this page you might lose some of these changes."
                            )}
                        </p>
                    </ConfirmDialog>
                    <AssortmentManageAccessDialog
                        onDismiss={this.handleToggleShareDialog}
                        merchantId={this.props.merchantId}
                        driveItemData={collectionDriveItem}
                        open={shareDialogOpen}
                        isRollupMode={isRollupMode}
                        brand={currentBrand}
                        me={me}
                    />
                    {productIdForModal && this.canShopBrand && !isRollupMode && (
                        <ProductDetailsModal
                            merchantId={collection.getIn(["merchant_id", "string_value"], "")}
                            onRequestClose={this.handleCloseProductModal}
                            modalOpen={!!productIdForModal}
                            productId={productIdForModal}
                            onFetchGlobalProducts={onFetchGlobalProducts}
                            globalProducts={globalProducts}
                            globalProductsIsFetching={isFetchingModal}
                            onSelectColorVariant={this.handlePreviewItem}
                            router={router}
                            onAddItem={this.handleAddItem}
                            itemDisplayProperty={detailDisplayFields}
                            brandEntities={brandEntities}
                            items={items}
                            editable={editable}
                            shopViewFields={shopViewFields}
                        />
                    )}
                </Page>
                {(recreateServerRollupSnapshot || this.state.collectionNotFoundInRollup) && (
                    <ReopenServerRollupDialog
                        snapshotId={serverRollupSnapshotId}
                        collectionIds={collection.getIn(["collections_refs"]).keySeq().toArray()}
                        open={recreateServerRollupSnapshot || this.state.collectionNotFoundInRollup}
                        merchantId={collection.getIn(["merchant_id", "string_value"], "")}
                        router={router}
                        createSnapshotError={createServerRollupSnapshotError}
                        collectionNotFoundInRollup={this.state.collectionNotFoundInRollup}
                    />
                )}
                {this.props.flags?.assortmentSettings &&
                    !isRollupMode &&
                    collectionDriveItem?.collection_facet?.collection_type === CollectionType.External &&
                    isCollectionSettingsOpen && (
                        <MarketSettingsModal
                            open={isCollectionSettingsOpen}
                            driveItemData={collectionDriveItem}
                            readonly={!editable}
                            onSaveSettings={this.handleSaveAssortmentSettings}
                            onClose={this.handleCloseAssortmentSettings}
                            rawItemDisplayProperty={itemDisplayProperty.toJS()}
                            merchantId={merchantId}
                            collectionItemMerchantId={collectionItemMerchantId}
                        />
                    )}
                {isConfigureShopViewOpen && (
                    <ManageShopView
                        itemDisplayProperty={itemDisplayProperty}
                        onConfirm={this.handleApplyShopViewSettings}
                        onClose={this.handleToggleConfigureShopView}
                        initialShopSettings={shopViewSettings}
                    />
                )}
            </div>
        );
    }

    private handleSendHeartbeat = () => {
        if (!this.heartbeatReturned) {
            clearInterval(this.sendHearbeat);
            // eslint-disable-next-line no-alert
            alert(
                "We seem to have encountered an unexpected error. Please copy any changes made in the last few minutes and refresh your browser"
            );
        }
        this.heartbeatReturned = false;
        this.props.onHeartbeatCheck();
    };

    private handleHearHeartbeat = () => {
        this.heartbeatReturned = true;
    };

    private handleBulkAddCatalogEntries = () => {
        const { itemsId, items, onAddBulkItems, router, location } = this.props;
        const { catalog } = router.params;
        const lastIndex = items ? items.size : 0;
        const productFilters = parseFilters(location);
        !this.isRollupMode &&
            onAddBulkItems(catalog, itemsId, lastIndex, this.baseAssortmetId, productFilters.get(IN_ASSORTMENT));
    };

    setInitialShopSettings = () => {
        this.setState({
            shopViewSettings: this.getInitialShopSettings(this.props.itemDisplayProperty),
            selectedShopViewSetting: DEFAULT_VIEW_SETTINGS,
        });
    };

    getInitialShopSettings = (itemDisplayProperty): IShopViewSettings => {
        const fieldName = itemDisplayProperty
            ?.find((field) => field?.get("kind") === Kinds.BRAND_NAME)
            ?.get("field_name");
        const { is_text, is_title, is_subtitle, is_color, is_cost, is_retail } =
            parseSchema(itemDisplayProperty).shopViewFields;
        const cost = is_cost?.path[1];
        const retail = is_retail?.path[1];

        return {
            firstLine: is_text?.path[1] ?? fieldName,
            secondLine: is_title?.path[1],
            thirdLine: is_subtitle?.path[1],
            fourthLine: is_color?.path[1],
            showCost: !!cost,
            showRetail: !!retail,
            cost,
            retail,
        };
    };

    private handleToggleConfigureShopView = () => {
        const { isConfigureShopViewOpen } = this.state;

        this.setState({
            isConfigureShopViewOpen: !isConfigureShopViewOpen,
        });
    };

    private handleApplyShopViewSettings = (settings) => {
        this.setState({
            shopViewSettings: settings,
            selectedShopViewSetting: CUSTOM_VIEW_SETTINGS,
            isConfigureShopViewOpen: false,
        });
    };

    private handleAddItem = (product) => {
        const { itemsId, items, onAddItem, router } = this.props;
        const productId = product._id;

        if (this.isRollupMode) {
            return;
        }

        return onAddItem({
            itemsId,
            attributes: {
                fields: {
                    id: { string_value: uuid() },
                    product_id: { string_value: productId },
                },
            },
            index: items ? items.size : 0,
            productId,
            collectionId: this.baseAssortmetId,
        });
    };

    private handleCloseProductModal = () => {
        const { router } = this.props;
        const newQuery = router.location.query;
        delete newQuery.productId;
        router.replace({
            pathname: router.location.pathname,
            query: {
                ...newQuery,
            },
        });
    };

    private handlePreviewItem = (product) => {
        const { router } = this.props;
        const newQuery = router.location.query;
        delete newQuery.productId;
        router.replace({
            pathname: router.location.pathname,
            query: {
                ...router.location.query,
                productId: product._id,
            },
        });
    };
    private handleToggleShareDialog = () => {
        this.setState({ shareDialogOpen: !this.state.shareDialogOpen });
    };

    private handleToggleChat = (on?: boolean) => {
        const showChat = on === undefined ? !this.state.showChat : on;
        if (!showChat) {
            this.props.onResetChatAlert();
        }
        this.setState({ showChat });
    };

    private handleNavigationPrevented = (route: string) => {
        this.setState({ nextLocation: route });
    };

    private setBreadcrumbs = () => {
        const { router, location, scope, catalog } = this.props;
        const { params } = router;
        const links: any = [];
        const { query } = location;
        let searchParams;
        let queryParams = "";

        if (query && query.filters) {
            try {
                searchParams = JSON.parse(query.filters).__search;
            } catch (error) {
                // Do nothing
            }
        }

        if (query && query.gridParams) {
            queryParams = `?gridParams=${query.gridParams}`;
        }

        const { id: assortmentId, brand: brandId } = params;
        if (params.brand) {
            links.push({
                displayName: scope.brand?.name,
                path: `/assortment/${assortmentId}/shop/brand/${scope.brand?._id || brandId}${queryParams}`,
            });

            if (params.catalog && catalog) {
                links.push({
                    displayName: catalog.title,
                    path: `/assortment/${assortmentId}/shop/brand/${scope.brand?._id}/catalog/${catalog.id}${queryParams}`,
                });
            }
        } else {
            links.push({
                displayName: formatMessage("All Brands"),
                path: `/assortment/${assortmentId}/shop`,
            });
        }

        if (searchParams) {
            links.push({
                displayName: formatMessage("Showing results for |searchParams|", { searchParams }),
            });
        }

        return links;
    };

    private hasEditPermissions() {
        const { location, capabilities } = this.props;
        let editable = false;
        if (!this.isRollupMode) {
            if (capabilities) {
                editable = capabilities.can_edit;
            }

            if (location.query.cartView === View.History) {
                editable = false;
            }
        }

        return editable;
    }

    private queueCheckForProductUpdates(timeout = TWO_MINUTES_IN_MS) {
        clearTimeout(this.checkForProductUpdatesTimer);
        this.checkForProductUpdatesTimer = undefined;
        this.checkForProductUpdatesTimer = setTimeout(this.performCheckForProductUpdates, timeout);
    }

    private performCheckForProductUpdates = () => {
        const { capabilities, onCheckForProductUpdates, collection } = this.props;
        this.checkForProductUpdatesTimer = undefined;
        if (capabilities && onCheckForProductUpdates && collection) {
            if (capabilities.can_edit) {
                const lastCheckedTimestamp = collection.getIn(["products_checked_at_ms", "number_value"]);
                if (!lastCheckedTimestamp || moment.utc(lastCheckedTimestamp).add(4, "hours").isBefore(moment.utc())) {
                    onCheckForProductUpdates();
                }
                this.queueCheckForProductUpdates(FOUR_HOURS_IN_MS);
            }
        }
    };

    private handleSubscribeToItemsUpdates = () => {
        !this.isRollupMode &&
            this.props.onSubscribeToItemsUpdates(this.baseAssortmetId, this.props.itemsId, this.props.sessionId);
    };

    private handleAcknowledgeError = () => {
        const { syncError, chatStateError, router } = this.props;
        if (chatStateError && chatStateError.status === 403) {
            router.push(DRIVE_LINK);
        } else if (syncError && syncError.status === 403) {
            if (!this.isRollupMode) {
                const { collectionRequestDeletePendingMutation } = this.props;
                collectionRequestDeletePendingMutation(this.baseAssortmetId, ITEMS_NAMESPACE, ITEMS_ID);
            }
            router.push(DRIVE_LINK);
        } else {
            this.windowReload();
        }
    };

    private handleKeyDown = (e: KeyboardEvent) => {
        const shouldDisableListener = disableKeydownListenerQueries.some((query) => query());

        if (shouldDisableListener) {
            return;
        }

        const z = e?.key?.toLowerCase() === KEYBOARD_KEYS.Z.toLowerCase();
        const y = e?.key?.toLowerCase() === KEYBOARD_KEYS.Y.toLowerCase();
        const backspace = e.key === KEYBOARD_KEYS.BACKSPACE;
        const shift = e.shiftKey;
        const ctrl = e.ctrlKey || e.metaKey;

        if (ctrl && !shift && z) {
            // We don't want to dispatch Assortment undo when we are focusing on an input
            if (!this.isElementInputFocused(e) && !this.isEditingCell() && this.hasEditPermissions()) {
                this.props.onUndo();
                e.preventDefault();
            }
        } else if ((ctrl && shift && z) || (ctrl && !shift && y)) {
            // We don't want to dispatch Assortment redo when we are focusing on an input
            if (!this.isElementInputFocused(e) && !this.isEditingCell() && this.hasEditPermissions()) {
                this.props.onRedo();
                e.preventDefault();
            }
        } else if (backspace && (this.isFocusAgCell(e) || (e.target as any)?.tagName === "BODY")) {
            e.preventDefault();
        }
    };

    private isElementInputFocused(e: KeyboardEvent) {
        return e.target && (e.target as HTMLElement).tagName === "INPUT" && document.activeElement === e.target;
    }

    private isFocusAgCell(e) {
        const { className } = e.target;
        return className.includes("ag-cell-focus");
    }

    // loop through all parent elements and see if we're in an ag-popup-editor (cell editor)
    private isEditingCell() {
        let editingCell = false;
        let thisTag = document.activeElement;

        while (thisTag.parentElement !== null && thisTag.parentElement.className !== "ag-popup-editor") {
            thisTag = thisTag.parentElement;
        }
        thisTag = thisTag.parentElement;

        if (thisTag && thisTag.className === "ag-popup-editor") {
            editingCell = true;
        }

        return editingCell;
    }
}

const getEntries = memoizeOne((collections, catalog) => {
    return (
        collections[catalog] || {
            results: [],
            isFetching: false,
            hasMoreResults: false,
            isBulkDeleting: false,
        }
    );
});

export const mapBrandEntitiesToDataById = memoizeOne((brands: any) => {
    let brandObject: any = {};
    for (const brandId in brands) {
        const brand = brands[brandId];
        for (const key in brand) {
            if (brand.hasOwnProperty(key)) {
                brandObject = {
                    ...brandObject,
                    [brand._id]: brand[key].toJS(),
                };
            }
        }
    }
    return brandObject;
});

const mapStateToProps = (state: IStore, ownProps) => {
    const validAssortmentIds = state.collection?.assortmentdIds;
    const {
        isRollupMode,
        rollupType,
        baseAssortmentId: _baseAssortmentId,
        assortmentIds,
    } = parseAssortmentId(ownProps.params.id);
    const baseAssortmentId =
        isRollupMode && validAssortmentIds?.length && validAssortmentIds[0] !== _baseAssortmentId
            ? validAssortmentIds[0]
            : _baseAssortmentId;
    const collection = state.mutate.snapshots && state.mutate.snapshots.get(baseAssortmentId);
    const itemsId = collection ? collection.getIn(["items", "ref", "object_id"]) : undefined;
    const itemDisplayProperty = collection ? collection.getIn(CollectionKeys.ITEM_DISPLAY_PROPERTY.KEYS) : undefined;
    const allowDuplicateProduct = collection?.getIn(
        CollectionKeys.ITEM_DISPLAY_PROPERTY.ALLOW_DUPLICATE_PRODUCT_ENTRIES
    );

    const { query } = ownProps.location;
    const { poi, viewId } = query;
    const historyCollection = poi && state.mutate.snapshots && state.mutate.snapshots.get(`${baseAssortmentId}-${poi}`);
    const historyItems =
        poi && state.mutate.snapshots && historyCollection && state.mutate.snapshots.get(`${itemsId}-${poi}`);
    const historyItemDisplayProperty =
        poi && historyCollection ? historyCollection.getIn(CollectionKeys.ITEM_DISPLAY_PROPERTY.KEYS) : undefined;
    let catalog;
    if (state.catalog.result.length) {
        catalog = state.catalog.entities.catalogs[state.catalog.result];
    }
    const isSaving = state.collection.syncingItems || state.collection.syncingCollection;
    const savingCount =
        (state.mutate.uncommittedMutations.get(itemsId) && state.mutate.uncommittedMutations.get(itemsId).size) || 0;
    const capabilities = state.collection?.driveItem?.capabilities;
    const collectionDriveItem = state.collection?.driveItem;
    const isCollectionSettingsOpen = state.collection?.isCollectionSettingsOpen;
    const sizingAllocationEnabled = state.collection.sizingAllocationEnabled;
    const listMerchantCollectionVersionStatutes = getActiveMerchantCollectionVersionStatus(state);
    const recreateServerRollupSnapshot = state.collection?.recreateServerRollupSnapshot;
    const serverRollupSnapshotId = state.collection?.serverRollupSnapshotId;
    const createServerRollupSnapshotError = state.collection?.createServerRollupSnapshotError;
    const assortmentBagVersion = collection?.get("bag_version");
    const rollupSnapshot = state.collection?.rollupSnapshot;

    return {
        hasAccessToBrand: state.accessControl.hasAccess,
        assortmentBagVersion,
        collection,
        rollupSnapshot,
        collectionDriveItem,
        capabilities,
        entries: getEntries(state.entries.collections, ownProps.router.params.catalog),
        chatState: state.collectionChat,
        chatStateError: state.collectionChat.error,
        chatMessageEntities: state.entities.chatMessages,
        catalog,
        catalogs: state.catalogs.entities.catalogs,
        itemDisplayProperty,
        itemsId,
        items: getCollectionItems(state, baseAssortmentId),
        bulkItems: state.bulkItems,
        hashtags: state.collection.hashtags,
        sessionId: state.collection.sessionId,
        merchantId: state.collection.merchantId,
        collectionItemMerchantId: state.collection.collectionItemMerchantId,
        gridApi: state.collection.gridApi,
        scrollToIndex: state.collection.scrollToIndex,
        collectionError: state.collection.error,
        focusOnCellMap: state.collection.focusOnCellMap,
        activeUserSessions: state.collection.activeUserSessions,
        syncingProducts: state.collection.syncingProducts,
        brandIds: state.collectionSidePanel.brands || [],
        brandEntities: state.entities.brands || {},
        brandsDataById:
            state.brandsData.payload?.brandsDataById || mapBrandEntitiesToDataById(state.entities.brands) || {},
        syncError: state.collection.syncError,
        app: state.app,
        isOutOfDate: state.collection.isOutOfDate,
        poiEntities: state.entities.collectionPOIs,
        scope: state.scope,
        isFetchingBrandsData: state.brandsData.isFetching,
        brandFetched: state.collectionSidePanel.brandFetched,
        preventNavigation: isSaving || !!savingCount,
        bulkAddingItems: state.collection.bulkAddingItems,
        historyItems,
        historyItemDisplayProperty,
        globalProducts: state.globalProducts.productsModal || List(),
        globalProductState: state.globalProducts,
        isFetchingModal: state.globalProducts.isFetchingModal,
        isFetchingProducts: state.collection.isFetchingProducts,
        variantIds: state.collection.variantIds,
        productError: state.collection.productError,
        productId: state.collection.productId,
        collectionProducts: state.entities.collectionProducts,
        collectionProduct: (state.entities.collectionProducts || {})[state.collection.productId],
        collectionItemsPendingMutation: state.collection.pendingMutations.get(ITEMS_ID),
        doors: getDoors(state, baseAssortmentId, poi),
        isRollupMode,
        rollupType,
        assortmentIds,
        assortmentIdsCollected: validAssortmentIds,
        sizingAllocationEnabled,
        allowDuplicateProduct,
        listMerchantCollectionVersionStatutes,
        poiTags: getCollectionTags(state, baseAssortmentId) ?? List(),
        recreateServerRollupSnapshot,
        serverRollupSnapshotId,
        createServerRollupSnapshotError,
        viewId,
        isCollectionSettingsOpen,
        dimensionsPanelApplied: state.dimensionsPanel.applied,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const { isRollupMode, rollupType, baseAssortmentId } = parseAssortmentId(ownProps.params.id);

    return {
        onFocusChange: (collectionId: string, itemsId: string, field: string) =>
            dispatch(actions.setSessionCellFocus(collectionId, itemsId, field)),
        onSubscribeToItemsUpdates: (collectionId, itemsId, sessionId) =>
            dispatch(actions.subscribeToItemsUpdates(collectionId, itemsId, sessionId)),
        onUnsubscribeToItemsUpdates: (collectionId, itemsId) =>
            dispatch(actions.unsubscribeToItemsUpdates(collectionId, itemsId)),
        onGetCollectionChatMessages: (collectionId, options) =>
            dispatch(actions.getCollectionChatMessages(collectionId, options)),
        onUnsubscribeToChatUpdates: ({ namespace, id }) =>
            dispatch(actions.unsubscribeToChatUpdates({ namespace, id })),
        onResetChat: ({ namespace, id, meta }) => dispatch(actions.resetChatState({ namespace, id, meta })),
        onGetOrCreateSession: (collectionId: string, userId: string, merchantId: string, editable: boolean) =>
            dispatch(actions.getOrCreateSession(collectionId, userId, merchantId, editable)),
        onClearSession: () => dispatch(actions.clearSession()),
        onSubscribeToSessionUpdates: (collectionId) => dispatch(actions.subscribeToSessionUpdates(collectionId)),
        onUnsubscribeToSessionUpdates: () => dispatch(actions.unsubscribeToSessionUpdates()),
        onFetchCollection: (ids: string[], isServerRollup: boolean, isCloseoutAssortmentEnabled: boolean) =>
            dispatch(
                actions.fetchCollectionById(
                    ids,
                    undefined,
                    isRollupMode,
                    rollupType,
                    isServerRollup,
                    isCloseoutAssortmentEnabled
                )
            ),
        onAddItem: (params) => dispatch(actions.addItem(params)),
        onAddBulkItems: (catalogId, itemsId, lastIndex, colletionId, filterInAssortment) =>
            dispatch(actions.addBulkItems(catalogId, itemsId, lastIndex, colletionId, filterInAssortment)),
        onMutateCollectionBudget: (collectionId: string, value: any) =>
            dispatch(actions.mutateBudget(collectionId, value)),
        onMutateCollectionItem: (itemsId, index, item, value?) =>
            dispatch(actions.mutateCollectionItem({ itemsId, index, item, value })),
        onRemoveItem: (itemsId, index) => dispatch(actions.removeItem(itemsId, index)),
        onMoveItem: (itemsId: string, index: number, destinationIndex: number, rowId: string) =>
            dispatch(actions.moveItem(itemsId, index, destinationIndex, rowId)),
        onBulkItemsAdd: (id) => dispatch(addToSelectedItems(id)),
        onBulkItemsRemove: (index) => dispatch(removeFromSelectedItems(index)),
        onBulkItemsClearAll: () => dispatch(clearAllSelectedItems()),
        onBulkItemsToggleSelectAll: () => dispatch(clearAllSelectedItems()),
        onDeleteItemsViaBulkItems: (itemsId, bulkItems, options?) =>
            dispatch(actions.removeItems(itemsId, bulkItems, options)),
        clearAllocations: (collectionId, bagType, itemId) =>
            dispatch(clearAllocationBag(collectionId, bagType, itemId)),
        onCreateCollectionAsset: (collectionId, uploadData, fileData, item, index, itemsId, key, assetIndex) => {
            return dispatch(
                actions.createCollectionAsset(collectionId, uploadData, fileData, item, index, itemsId, key, assetIndex)
            );
        },
        onGridMount: (gridApi, columnApi) => dispatch(actions.registerGridApi(gridApi, columnApi)),
        onUpdateCollectionAttribute: (id, prop, value, reset) =>
            dispatch(actions.updateCollectionAttribute(id, prop, value, reset)),
        onOpenOrCloseCollectionSettings: (payload) => dispatch(actions.openOrCloseCollectionSettings(payload)),
        onUpdateCollectionSettings: (payload) => dispatch(actions.updateCollectionSettings(payload)),
        onDeleteCollection: (id) => dispatch(actions.deleteCollection(id)),
        onFetchContacts: (search: string, merchant_id: string, brandId?: string) =>
            dispatch(actions.fetchContacts(search, merchant_id, brandId)),
        onCheckForProductUpdates: () => !isRollupMode && dispatch(actions.checkForProductUpdates(baseAssortmentId)),
        onSyncProductsStart: () => dispatch(actions.syncProductsStart({ collectionId: baseAssortmentId })),
        onSyncProductsStop: () => !isRollupMode && dispatch(actions.syncProductsStop()),
        onFetchBrandsData: (query) => dispatch(fetchBrandsData({ query })),
        onFetchSingleBrand: (brandId) => dispatch(fetchSingleBrand(brandId, me.isBuyer())),
        onFetchBrands: (options?) => dispatch(fetchBrands(options)),
        onClearProductUpdates: () => dispatch(actions.clearProductUpdates()),
        onClearCollection: (itemsId?) => dispatch(actions.clearCollection(itemsId)),
        onCreateNordstromPush: (params) => dispatch(actions.createNordstromMessage(params)),
        onFetchGlobalProducts: (params) => dispatch(fetchGlobalProducts(params)),
        onFetchNextGlobalProducts: (params) => dispatch(fetchNextGlobalProducts(params)),
        onResetGlobalProducts: (params) => dispatch(resetGlobalProducts(params)),
        onUndo: (_e: React.MouseEvent<HTMLElement>) =>
            !isRollupMode && dispatch(collectionHistoryUndo(baseAssortmentId)),
        onRedo: (_e: React.MouseEvent<HTMLElement>) =>
            !isRollupMode && dispatch(collectionHistoryRedo(baseAssortmentId)),
        onCreateCollectionChatMessage: (collectionId: string, data: any, meta?: any) =>
            dispatch(actions.createCollectionChatMessage(collectionId, data, meta)),
        onDeleteCollectionChatMessage: (messageId: string, chatThreadId: string, collectionId) => {
            return dispatch(actions.deleteCollectionChatMessage(messageId, chatThreadId, collectionId));
        },
        onResetChatAlert: () => dispatch(actions.resetChatAlert()),
        onResetChatState: ({ namespace, id, meta }) => dispatch(actions.resetChatState({ namespace, id, meta })),
        onFetchProducts: (productId: string, brandId: string) => dispatch(fetchProducts(productId, brandId)),
        onHeartbeatCheck: () => dispatch(actions.heartbeatCheck()),
        collectionRequestDeletePendingMutation: (documentId, objectNamespace, objectId) =>
            dispatch(actions.collectionRequestDeletePendingMutation(documentId, objectNamespace, objectId)),
        collectionGridXlsExport: (collection, assortmentIds) =>
            dispatch(actions.gridXlsExport(collection, assortmentIds)),
        collectionRetrySync: (objectNamespace, objectId) => dispatch(retrySync(objectNamespace, objectId)),
        collectionClearSyncError: () => dispatch(actions.syncErrorClear()),
        getMerchantDefaultAllocationDimensionsPreference: (merchantId: string) =>
            dispatch(getMerchantDefaultAllocationDimensionsPreferenceRequest(merchantId)),
    };
};

export const ProductCollectionPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(withLDConsumer()(ProductCollectionPage));
export default ProductCollectionPageContainer;
